var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.shop_list, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var g0 = _vm.shop_list[index].productList.length
    var g1 = g0 > 0 ? _vm.shop_list[index].productList.length : null
    return {
      $orig: $orig,
      g0: g0,
      g1: g1,
    }
  })
  var g2 = _vm.shop_list.length == 0 && !_vm.loading
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        g2: g2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }